import PlayPositions from "@Enums/PlayPositions";
import StorageKeys from "@Enums/StorageKeys";
import appStorage from "@Context/storage";

/**
 * Load selected positions from local storage
 * @returns Array of PlayPositions or empty array if none found/invalid
 */
export const loadPositionsFromStorage = (key: StorageKeys = StorageKeys.SELECTED_POSITIONS): PlayPositions[] => {
  try {
    const storedPositions = appStorage.get({ key });
    return Array.isArray(storedPositions) ? storedPositions : [];
  } catch (error) {
    console.warn("Failed to load positions from storage:", error);
    return [];
  }
};

/**
 * Save selected positions to local storage
 * @param positions Array of PlayPositions to store
 */
export const savePositionsToStorage = (positions: PlayPositions[], key: StorageKeys = StorageKeys.SELECTED_POSITIONS): void => {
  try {
    appStorage.set({
      key,
      data: positions,
      expiry: [30, "days"], // Store positions for 30 days
    });
  } catch (error) {
    console.warn("Failed to save positions to storage:", error);
  }
};

/**
 * Clear stored positions from local storage
 */
export const clearStoredPositions = (key: StorageKeys = StorageKeys.SELECTED_POSITIONS): void => {
  try {
    appStorage.remove({ key });
  } catch (error) {
    console.warn("Failed to clear positions from storage:", error);
  }
};
